import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "questionAnswer",
  "use": "questionAnswer-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol viewBox=\"0 0 20 20\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"questionAnswer\">\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M15 2V9C15 10.1 14.1 11 13 11H4L0 15V2C0 0.9 0.9 0 2 0H13C14.1 0 15 0.9 15 2ZM17 4H18C19.1 4 20 4.9 20 6V20L16 16H6C4.9 16 4 15.1 4 14V13H16C16.55 13 17 12.55 17 12V4Z\" fill=\"#26A69A\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/sharedComponents/Icon/images/questionAnswer.svg
// module id = qGoq
// module chunks = 13